export function pttVisibleStatus(isMicActive) {
    return isMicActive ? 'listening' : 'ready';
}
export function shouldAcceptProviderSpeechStarted(isMicActive) {
    return isMicActive;
}
export function mayActivatePtt(status) {
    return status === 'ready' || status === 'speaking' || status === 'listening';
}
//# sourceMappingURL=PttPolicy.js.map